import type { MeetingTemplateKind } from '@wundo/shared/meetingTemplate.ts';

export interface MeetingTemplateViewLabels {
  back: string;
  /** Under the name of a template this reader may not change. */
  readOnlyNote: string;
  topicsTitle: string;
  kindLabel: string;
  /** What each kind of meeting is called, as a value rather than a heading. */
  kinds: Record<MeetingTemplateKind, string>;
}

export const DEFAULT_MEETING_TEMPLATE_VIEW_LABELS: MeetingTemplateViewLabels = {
  back: 'Back to templates',
  readOnlyNote: 'Set by your organisation.',
  topicsTitle: 'Topics',
  kindLabel: 'Kind of meeting',
  kinds: {
    one_on_one: '1:1',
    team: 'Team meeting',
    other: 'Other',
  },
};
